// extracted by mini-css-extract-plugin
module.exports = {"returnValue":"_7ce58cd","returnValueOddsChanged":"_a39e823","returns":"_ae7178b"};